import { Col, Row } from "react-bootstrap";
import {
  LineChart,
  Line,
  ReferenceArea,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

const data = [
  {
    year: "01",
    "Sales Revenue": 7660800000,
    "Break-Even Revenues": 3652488575,
  },
  {
    year: "02",
    "Sales Revenue": 42681600000,
    "Break-Even Revenues": 18181708784,
  },
  {
    year: "03",
    "Sales Revenue": 99809280000,
    "Break-Even Revenues": 39815075676,
  },
  {
    year: "04",
    "Sales Revenue": 162846720000,
    "Break-Even Revenues": 60556796757,
  },
  {
    year: "05",
    "Sales Revenue": 231575040000,
    "Break-Even Revenues": 60570418378,
  },
];

const CustomDot = () => null;

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div className="custom-chart-tooltip">
        <p className="label">{`${label} : ${payload[0].value}`}</p>
      </div>
    );
  }

  return null;
};

const COLORS = ["#2ECA7F", "#D71F26"];

function formatNumber(num) {
  return num.toLocaleString(undefined, { maximumFractionDigits: 0 });
}

const BreakEvenChart = () => {
  const referenceAreas = data.map((item, index) => (
    <ReferenceArea
      key={`ref-area-${index}`}
      x1={item.year}
      x2={data[index + 1] ? data[index + 1].year : item.year}
      y1={Math.min(item["Sales Revenue"], item["Break-Even Revenues"])}
      y2={Math.max(item["Sales Revenue"], item["Break-Even Revenues"])}
      fill="#3E3E3E"
      fillOpacity={1}
      radius={10}
    />
  ));

  return (
    <>
      <div className="px-5 pt-5 pb-4">
        <ResponsiveContainer width="100%" height={400}>
          <LineChart data={data}>
            <CartesianGrid opacity={0.5} vertical={false} />
            <XAxis dataKey="year" tickLine={false} tick={false} />
            <YAxis
              axisLine={false}
              tickLine={false}
              width={130}
              tickFormatter={(value) => `$${value}`}
              tickCount={6}
            />
            <Tooltip content={<CustomTooltip />} />
            <Line
              type="monotone"
              dataKey="Sales Revenue"
              stroke="#D71F26"
              dot={<CustomDot />}
              strokeWidth={2}
            />
            <Line
              type="monotone"
              dataKey="Break-Even Revenues"
              stroke="#2ECA7F"
              dot={<CustomDot />}
              strokeWidth={2}
            />
            {referenceAreas}
          </LineChart>
        </ResponsiveContainer>
      </div>
      <div className="chart-stats pt-3">
        {/* <Row>
          <Col md={2}></Col>
          {data.map((item) => {
            return (
              <>
                <Col md={2}>
                  <p className="legend-cell">{item.year}</p>
                </Col>
              </>
            );
          })}
        </Row> */}
        <Row className="padding-from-left-for-chart">
            <Col className="text-center col col-md-2">
              <p className="legend-cell_1">Year</p>
            </Col>
            {data.map((item) => {
              return (
                <>
                  <Col className="col col-md-2">
                    <p className="legend-cell_1">{item["year"]}</p>
                  </Col>
                </>
              );
            })}
          </Row>
        <Row>
          <Col md={2}>
            <div className="p-3 light-bg">
              <div className="legend-entry">
                <div
                  className="square-dot"
                  style={{ backgroundColor: COLORS[0] }}
                ></div>
                <span className="dark">COGS</span>
              </div>
              <div className="legend-entry last">
                <div
                  className="square-dot"
                  style={{ backgroundColor: COLORS[1] }}
                ></div>
                <span className="dark">Net Profit</span>
              </div>
            </div>
          </Col>
          {data.map((item) => {
            return (
              <>
                <Col md={2} className="p-3 hide-on-responsive">
                  <p className="legend-cell">
                    $ {formatNumber(item["Sales Revenue"])}
                  </p>
                  <p className="legend-cell">
                    $ {formatNumber(item["Break-Even Revenues"])}
                  </p>
                </Col>
              </>
            );
          })}
        </Row>
      </div>
    </>
    // ======================================================
  );
};

export default BreakEvenChart;
